export var MOSAIC_CONFIGURATION_API = 'mosaic/configuration';
export var ORDER_TEMPLATES_API = 'orders/order-templates';
